import { render, staticRenderFns } from "./BtwSection.vue?vue&type=template&id=846762d8&scoped=true&"
import script from "./BtwSection.vue?vue&type=script&lang=js&"
export * from "./BtwSection.vue?vue&type=script&lang=js&"
import style0 from "./BtwSection.vue?vue&type=style&index=0&id=846762d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846762d8",
  null
  
)

export default component.exports